<template>
<div id="app" v-loading="loading">
    <router-view v-if="!loading"/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
         loading:true,
      };
    },
    mounted() {
      var tokens = this.$getCookie('sd_token');
      if(tokens != undefined){
          //  this.initpage();
      }else{
        this.loading = false;
      }
    },
    methods: {
      initpage(){
        var _this = this;
        _this.$api.checklogin({
        }).then(res => {
          if (res.code == 200){
            if(res.data == 0){
              _this.$delCookie('sd_token');
            }
          }else{
            _this.$delCookie('sd_token');
          }
          this.loading = false;
        }).catch(function (error) {
          _this.$message.error(error.msg);
        });
      },
    }
  }
</script>

<style lang="less">
  body{
    min-width: 1200px;
  }
  ::-webkit-scrollbar{
    width: 0 !important;
    height: 0 !important;
  }
</style>
